import React from 'react';

const AboutSkillCard = ({ title, items }) => {
  return (
    <div className="skill-category">
      <h4>{title}</h4>
      <ul>
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default AboutSkillCard;